import { render, staticRenderFns } from "./mathStudy.vue?vue&type=template&id=c4f1f5fc&scoped=true&"
import script from "./mathStudy.vue?vue&type=script&lang=js&"
export * from "./mathStudy.vue?vue&type=script&lang=js&"
import style0 from "./mathStudy.vue?vue&type=style&index=0&id=c4f1f5fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f1f5fc",
  null
  
)

export default component.exports